import { cn } from 'src/utils/cn'
import { forwardRef } from 'react'

const Section = forwardRef(({ children, className }, ref) => {
  return (
    <section
      ref={ref}
      className={cn(
        'max-w-360 mx-auto flex flex-col items-center px-5 py-12 lg:py-16',
        className
      )}
    >
      <div className="max-w-272 w-full">{children}</div>
    </section>
  )
})

Section.displayName = 'Section'

export default Section
